var React = require('react');

function Pending (props) {
    return React.createElement("svg",props,React.createElement("g",{"data-name":"Group 1399"},[React.createElement("path",{"fill":"#fff","d":"M22.783 0A22.783 22.783 0 1 1 0 22.783 22.783 22.783 0 0 1 22.783 0Z","data-name":"Ellipse 6 copy 2","key":0}),React.createElement("path",{"fill":"#acacac","d":"M22.714 39.642a17.006 17.006 0 0 1-16.858-14.8h17.082v-19.2a17 17 0 0 1-.224 34Z","data-name":"Subtraction 11","key":1})]));
}

Pending.defaultProps = {"viewBox":"0 0 45.566 45.566"};

module.exports = Pending;

Pending.default = Pending;
